import { State } from '../../reducer';
import namespace from './namespace';
import { createSelector } from 'reselect';

const getAccountState = (state: State) => state[namespace].account;
export const getAccountSelector = createSelector([getAccountState], (s) => s);

const getShowWelcomeModalState = (state: State) => state[namespace].showWelcomeModal;
export const getShowWelcomeModalSelector = createSelector([getShowWelcomeModalState], (s) => s);
